import styled from "styled-components";

export const LogoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  div:nth-child(1) {
    display: flex;
    align-items: center;
    gap: 10px;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 50%;
    }
    span {
      font-weight: 600;
      text-transform: capitalize;
      color: black;
    }
  }
  div:nth-child(3) {
    display: flex;
    align-items: center;
    gap: 10px;
    button {
      padding: 10px 25px;
      border-radius: 10px;
      color: #000;
      border: 1px solid #88888896;
    }
    button:nth-child(2) {
      color: #aa0505;
      background: #f9bfbf77;

      &:hover{
      background: #f26f6f77;
      }
    }
  }
`;
